import axios from 'axios';
import React, { Fragment, useContext, useEffect, useState } from 'react' ;
import { toast } from 'react-toastify';
import { UserContext } from '../../../Context/UserContext.js';
import { Link } from 'react-router-dom';

export default function PaidCashOrder() {
   const[paymentOrder , setPaymentOrder] = useState([]) ;
   const {userToken } = useContext(UserContext) ;

   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   async function getData (){
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/order?is_Paid=false`  ,  {headers:header} )
      .then(({data})=>{
         if(data.message === "success"){
            setPaymentOrder(data.orders);
         }
      })
      .catch((error)=>{
         setPaymentOrder([]);
         // toast.error(error.response?.data?.message)
      })
   }
   
   async function paidOrder (orderId){
      const values = {
         orderId ,
         is_Paid : "true"
      }
      await axios.patch(`${process.env.REACT_APP_BASE_URL}/api/v1/order/paidOrder` ,  {...values} ,  {headers:header} )
      .then(({data})=>{
         toast.success(data?.message)
         getData()
      })
      .catch((error)=>{
         getData()
         toast.error(error.response?.data?.message)
      })
   }
   

   useEffect(() => {
      getData()
   }, [])

   return (
      <Fragment>
         <div className="container-fluid homeDashboard">
            {paymentOrder.length > 0 ? 
               <div className="table">
                  <table className='table table-sm text-center table-group-divider table-striped table-responsive-md '>
                     <thead>
                        <th>Order Number</th>
                        <th>Patient</th>
                        <th>Company</th>
                        <th>Payment</th>
                        <th>Method</th>
                        <th>Net Amount</th>
                        <th>Status</th>
                        <th>Date And Time</th>
                        <th>Action</th>
                     </thead>
                     <tbody>
                        {paymentOrder.length? 
                        <>
                           {paymentOrder.map((ele)=>
                              <tr key={ele._id}>
                                 <td>{ele.order_Number}</td>
                                 <td className='fullName'>{ele.patient_Name}</td>
                                 <td>{ele.company?.name}</td>
                                 <td>{ele.total_Price_After_Discount}</td>
                                 <td>{ele.payment_Type}</td>
                                 <td>{ele.Net_Amount}</td>
                                 <td>
                                 {
                                    ele.is_Cancel?
                                       <p className='alert alert-danger  fw-bold text-center p-1'>إلغاء الطلب</p>
                                    :ele.is_Approved && ele.is_Paid? 
                                       <p className='alert alert-secondary fw-bold text-center p-1 text-success'>تم سحب العينات</p>
                                    : ele.is_Paid ?
                                       <p className='alert alert-success fw-bold text-center p-1'> تم تسجيل الطلب</p>
                                    : !ele.is_Paid ?
                                       <p className='alert alert-success fw-bold text-center p-1'>انتظار موافقة الادمن</p>
                                    :<p className='alert alert-primary fw-bold text-center p-1' >حدث خطأ اثناء التسجيل</p>
                                 }
                                 </td>
                                 <td>{ele.createdAt.slice(0 , 10)}</td>
                                 {/* <td>{ele.createdAt.slice(0 , 10)} <br/> {ele.createdAt.slice(10 ,19 ).split("T")}</td> */}
                                 <td>
                                    <button onClick={()=>{paidOrder(ele._id)}} className='btn btn-sm bg-main'>Paid</button>
                                 </td>
                              </tr>
                           )}
                        </> : <div className='alert alert-danger p-1'>Order Not Found</div>}
                     </tbody>
                  </table>
               </div>
            :
               <h3 className='text-center text-danger'>! ... لا يوجد اى طلبات سابقة </h3>
            }
         </div>
      </Fragment>
   )
}
